import React from 'react';

import { fieldStyles } from './field-shell';

export interface RequiredMarkProps {
  /**
   * Reads the asterisk to assistive technology. Leave it off beside a
   * control that announces `aria-required` itself (a text entry, a radio
   * group); set it where the control cannot carry it (a button, a group of
   * checkboxes, a file input).
   */
  announces?: boolean;
}

/**
 * The asterisk after a field's name. ComplyKit's fields place it themselves;
 * it is public for a name the caller renders, a question's text that names
 * its answer through `aria-labelledby` (field.md, "Required, disabled,
 * read-only").
 */
export const RequiredMark = React.forwardRef<HTMLSpanElement, RequiredMarkProps>(
  function RequiredMark({ announces = false }, ref) {
    const { required } = fieldStyles();
    return (
      <span ref={ref} aria-hidden={announces ? undefined : 'true'} className={required()}>
        {' *'}
      </span>
    );
  },
);
